import React, { useEffect, useRef } from "react";

// Selo do Reclame Aqui (05/10/2026). O código de instalação vem do painel da JoinKids no Reclame Aqui.
// Enquanto SELO estiver vazio, nada aparece. O script do selo só roda no navegador de quem visita:
// a "fotografia" de publicação (scripts/prerender.js) bloqueia o Reclame Aqui, para o selo não sair
// desenhado na foto e de novo no navegador (selo duplicado).
// Código do painel (RA Verificada, modelo horizontal_1), passado pelo dono em 05/10/2026. É público: qualquer
// visitante vê este código no site. O data-id é a identificação da JoinKids no Reclame Aqui.
const SELO = {
    src: "https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js",
    alvo: "ra-verified-seal",
    atributos: {
        id: "ra-embed-verified-seal",
        "data-id": "dl9xZTJXb2RVWU5wcVFnSTpqb2lua2lkcy1lbnRyZXRlbmltZW50bw==",
        "data-target": "ra-verified-seal",
        "data-model": "horizontal_1",
    },
};

export default function SeloReclameAqui({ estilo }){
    const caixa = useRef(null);

    useEffect(() => {
        if (!SELO || !caixa.current || caixa.current.querySelector("script")) return;
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = SELO.src;
        Object.entries(SELO.atributos || {}).forEach(([nome, valor]) => s.setAttribute(nome, valor));
        caixa.current.appendChild(s);
    }, []);

    if (!SELO) return null;
    return <div id={SELO.alvo} ref={caixa} style={{ margin: "16px 0 0", ...estilo }} />;
}
